export default __webpack_public_path__ + "static/media/Neophyte's Boots of Secret Doors.e4b3b1ad.jpg";